'use es6';

import React from 'react';
import { getLogoNamePropType } from '../utils/propTypes/logoName';
import UIAbstractIllustration from './UIAbstractIllustration';

var UILogo = function UILogo(props) {
  return React.createElement(UIAbstractIllustration, props);
};

UILogo.defaultProps = UIAbstractIllustration.defaultProps;
UILogo.propTypes = Object.assign({}, UIAbstractIllustration.propTypes, {
  name: getLogoNamePropType().isRequired
});
UILogo.displayName = 'UILogo';
export default UILogo;